<ng-container *ngIf="courseLoadStatus == 'Loading'">
  <app-load-indicator description="load course details"></app-load-indicator>
</ng-container>
<ng-container *ngIf="courseLoadStatus == 'NotFound'">
  <app-dynamic-content blocktitle="Course Not Found"></app-dynamic-content>
</ng-container>
<ng-container *ngIf="courseLoadStatus == 'NoAccess'">
  <app-dynamic-content blocktitle="Inaccessible Course"></app-dynamic-content>
</ng-container>
<ng-container *ngIf="courseLoadStatus == 'Archived'">
  <app-dynamic-content blocktitle="Archived Course"></app-dynamic-content>
</ng-container>
<ng-container *ngIf="courseLoadStatus == 'Loaded'">
  <ng-container *ngIf="(ucdService.User | async) as user">
    <ng-container *ngIf="(dynamicCourse$ | async) as course">
      <h1>{{course.title}}<ng-container *ngIf="course.library=='WMC'"> (WMC)</ng-container></h1>
      <h2 class="coursesubtitle" *ngIf="course.subtitle">{{ course.subtitle }}</h2>
      <h4>
        <app-course-author-list [authors]="course.authors" [link]="true" title="Show author biography"></app-course-author-list>
      </h4>
      <app-dynamic-content
        *ngIf="user.CheckMemberGroup('ABMP', 'StudentFSN') || user.GetMemberTypes('ABMP').includes('Non-Member')"
        blocktitle="Marketing - Course Page Top - {{course.type}} {{user.GetMemberTypes('ABMP').shift()}}">
      </app-dynamic-content>
      <app-dynamic-content *ngIf="!ucdService.IsLoggedIn"
        blocktitle="Marketing - Course Page Top - {{course.type}} Anonymous">
      </app-dynamic-content>
      <app-add-course-to-cart [course]="course" *ngIf="!course.IsCEActive()"></app-add-course-to-cart>
      <app-course-tag-bar [course]="course"></app-course-tag-bar>
      <span class="coursestatus" *ngIf="ucdService.IsLoggedIn">Status:
          {{ pendingStatusChange ? 'Updating...' : course.userData.Status }}</span>
    </ng-container>

    <div class="d-flex flex-wrap">
      <ng-container *ngIf="(stableCourse$ | async) as course">
        <ng-container *ngIf="course.rights.includes('viewcontent');">
          <div [ngSwitch]="course.typeid" class="text-center mb-3 mr-1" id="coursecontent" (click)="GetTheZoomies()"
            [@biggifyImage]="bigImage">
            <app-course-content-display-pdf *ngSwitchCase="'ebook'" [course]="course"
              (pendingStatusChange)="updatePendingStatusChange($event)">
            </app-course-content-display-pdf>
            <app-course-content-display-link *ngSwitchCase="'mb_article'" [course]="course"
              (pendingStatusChange)="updatePendingStatusChange($event)">
            </app-course-content-display-link>
            <app-course-content-display-pdf *ngSwitchCase="'mb_article_bundle'" [course]="course"
              (pendingStatusChange)="updatePendingStatusChange($event)">
            </app-course-content-display-pdf>
            <app-course-content-display-webinar *ngSwitchCase="'webinar'" [course]="course"
              (pendingStatusChange)="updatePendingStatusChange($event)">
            </app-course-content-display-webinar>
            <app-course-content-display-webinar *ngSwitchCase="'wmc_webinar'" [course]="course"
              (pendingStatusChange)="updatePendingStatusChange($event)">
            </app-course-content-display-webinar>
          </div>
        </ng-container>
        <ng-container *ngIf="!course.rights.includes('viewcontent');">
          <div class="text-center mb-3 mr-1" id="coursecontent">
            <app-course-content-display-splash-only [course]="course"></app-course-content-display-splash-only>
          </div>
        </ng-container>
      </ng-container>
      <div class="flex-shrink-0 pl-2" id="courseextras">
        <ng-container *ngIf="(dynamicCourse$ | async) as course">
          <app-supplementary-material-list *ngIf="course.rights.includes('viewcontent');" [course]="course"
            layout="card">
          </app-supplementary-material-list>
          <a routerLink="." fragment="related-courses" class="d-block ml-1"
            *ngIf="this.course.related_courses && this.course.related_courses.length > 0">Related Courses</a>
          <ng-container *ngIf="(ucdService.GetCourseBundles$(course.netforum_course_id) | async) as bundles">
            <a routerLink="." fragment="related-bundles" class="d-block ml-1"
              *ngIf="bundles && bundles.length > 0">Discount Packages with this course</a>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="(dynamicCourse$ | async) as course">
      <app-state-approval-alert [course]="course"></app-state-approval-alert>

      <p [innerHTML]="course.description" class="grey-text"></p>

      <app-dynamic-content *ngIf="course.library=='WMC'" blocktitle="WMC Course Page Intro"></app-dynamic-content>

      <app-dynamic-content *ngIf="!ucdService.IsLoggedIn" blocktitle="Course Page Upsell {{course.type}}">
      </app-dynamic-content>

      <ng-container *ngIf="ucdService.IsLoggedIn">
        <app-dynamic-content *ngIf="!ucdService.IsLoggedIn" blocktitle="Marketing - Course Page - Anonymous">
        </app-dynamic-content>
        <ng-container *ngIf="ucdService.User | async as user">
          <app-dynamic-content
            *ngIf="!user.CheckMemberGroup('ABMP', 'StudentFSN') && !user.GetMemberTypes('ABMP').includes('Non-Member')"
            blocktitle="Marketing - Course Page - {{course.type}} {{user.GetMemberTypes('ABMP').shift()}}">
          </app-dynamic-content>
        </ng-container>

        <ng-container *ngIf="course.creditNumber > 0; else zeroCredit">
          <h5>CE
            {{ course.userData.Status == 'CE Pending' || course.userData.Status == 'CE Earned' ? 'Certificate | Learners can earn one CE certificate per course.' :
            'Questions' }}
          </h5>
          <p *ngIf="pendingStatusChange">
            <app-load-indicator description="update this course"></app-load-indicator>
          </p>
          <ng-container *ngIf="course.rights.includes('cequiz'); else noCEQuizBlock">
            <div [ngSwitch]="course.userData.Status">
              <app-cequiz [courseid]="course.netforum_course_id" *ngSwitchCase="'CE Available'"></app-cequiz>
              <p *ngSwitchCase="'CE Pending'">
                <app-dynamic-content [blocktitle]="'CE Pending'"></app-dynamic-content>
                <app-course-evaluation [course]="course"></app-course-evaluation>
              </p>
              <div *ngSwitchCase="'CE Earned'">
                <p *ngIf="course.rights.includes('cecertificate');else noCECertificateBlock"><a
                    href="{{certificateLink}}" target="_blank">Click
                    here to download your CE certificate</a>.</p>
                <app-course-evaluation [course]="course"></app-course-evaluation>
              </div>
              <p
                *ngSwitchCase="['Not Started', 'Started', 'Purchased'].includes(course.userData.Status) ? course.userData.Status : ''">
                <app-dynamic-content [blocktitle]="'CE Threshold Not Reached - ' + course.type">
                </app-dynamic-content>
              </p>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="(dynamicCourse$ | async) as course">
          <h4>{{course.title}}<ng-container *ngIf="course.library=='WMC'"> (WMC)</ng-container>
          </h4>
          <ng-container *ngIf="(dynamicCourse$ | async) as course">
            <app-supplementary-material-list *ngIf="course.rights.includes('viewcontent');" [course]="course"
              layout="inline">
            </app-supplementary-material-list>
            <app-related-course-list [course]="course"></app-related-course-list>
            <app-related-bundle-list [course]="course"></app-related-bundle-list>
          </ng-container>
          <div *ngIf="course.seo_content_outline" [innerHTML]="'<h6>Course Outline</h6>' + course.seo_content_outline">
          </div>
          <div *ngIf="course.seo_content_objectives"
            [innerHTML]="'<h6>Learning Objectives</h6>' + course.seo_content_objectives"></div>
          <div *ngIf="course.authors.length > 0">
            <h6>Instructors</h6><a name="authors"></a>
            <app-course-author-seo-list [authors]="course.authors"></app-course-author-seo-list>
          </div>
          <div *ngIf="course.seo_content_topic_techs"
            [innerHTML]="'<h6>Topics and Techniques</h6>' + course.seo_content_topic_techs"></div>
          <div *ngIf="course.seo_content_date" [innerHTML]="'<h6>Date</h6>' + course.seo_content_date"></div>
          <div *ngIf="course.seo_content_faq" [innerHTML]="'<h6>FAQ</h6>' + course.seo_content_faq"></div>
          <div *ngIf="course.seo_content_reviews" [innerHTML]="'<h6>Reviews</h6>' + course.seo_content_reviews"></div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

</ng-container>
<ng-container *ngIf="(ucdService.User | async) as user">
  <app-sales-box *ngIf="!ucdService.IsLoggedIn || user.GetMemberTypes('ABMP').includes('Non-Member')"></app-sales-box>
  <ng-container *ngIf="!ucdService.IsLoggedIn">
    <ng-container *ngIf="(dynamicCourse$ | async) as course">
      <h4>{{course.title}}<ng-container *ngIf="course.library=='WMC'"> (WMC)</ng-container>
      </h4>
      <ng-container *ngIf="(dynamicCourse$ | async) as course">
        <app-supplementary-material-list *ngIf="course.rights.includes('viewcontent');" [course]="course">
        </app-supplementary-material-list>
        <app-related-course-list [course]="course"></app-related-course-list>
        <app-related-bundle-list [course]="course"></app-related-bundle-list>
      </ng-container>
      <div *ngIf="course.seo_content_outline" [innerHTML]="'<h6>Course Outline</h6>' + course.seo_content_outline">
      </div>
      <div *ngIf="course.seo_content_objectives"
        [innerHTML]="'<h6>Learning Objectives</h6>' + course.seo_content_objectives"></div>
      <div *ngIf="course.authors.length > 0">
        <h6>Instructors</h6><a name="authors"></a>
        <app-course-author-seo-list [authors]="course.authors"></app-course-author-seo-list>
      </div>
      <div *ngIf="course.seo_content_topic_techs"
        [innerHTML]="'<h6>Topics and Techniques</h6>' + course.seo_content_topic_techs"></div>
      <div *ngIf="course.seo_content_date" [innerHTML]="'<h6>Date</h6>' + course.seo_content_date"></div>
      <div *ngIf="course.seo_content_faq" [innerHTML]="'<h6>FAQ</h6>' + course.seo_content_faq"></div>
      <div *ngIf="course.seo_content_reviews" [innerHTML]="'<h6>Reviews</h6>' + course.seo_content_reviews"></div>
    </ng-container>
  </ng-container>
</ng-container>


<ng-template #noCEQuizBlock>
  <app-dynamic-content [blocktitle]="'No CE Quiz Permission'"></app-dynamic-content>
</ng-template>
<ng-template #noCECertificateBlock>
  <app-dynamic-content [blocktitle]="'No CE Certificate Permission'"></app-dynamic-content>
</ng-template>
<ng-template #zeroCredit>
  <app-dynamic-content [blocktitle]="'Zero Credit Course'"></app-dynamic-content>
</ng-template>